export enum FacilitatorMessagingFields {
  TITLE = 'title',
  MESSAGE = 'message',
  TEAM_NAME = 'teamName',
  PARTICIPANT_LOGIN = 'participantLogin',
}
